import { useMutation } from "@tanstack/react-query";
import { submitSelfDeclarationApi } from "../../api/distributor/self-declaration";

export function useSubmitSelfDeclaration() {
  return useMutation({
    mutationFn: submitSelfDeclarationApi,
  });
}
